// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__bPiza","FullPage":"Loading_FullPage__2qa1h","LoadingContent":"Loading_LoadingContent__2Pbdc","spinner":"Loading_spinner__2U6FN"};